var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

var jade_indent = [];
buf.push("\n<form ng-submit=\"saveFile(newFile)\" name=\"form\">\n  <div class=\"select\">\n    <select ng-options=\"customerSystem.id as customerSystem.name for customerSystem in values(customerSystems) | orderBy:'name'\" ng-model=\"newFile.customerSystemId\">\n      <option value=\"\">{{ t('fileModalChooseCustomSystem') }}</option>\n    </select>\n  </div>\n  <input type=\"file\" ng-show=\"newFile.customerSystemId\" ng-model=\"newFile.file\" file-on-change required>\n  <div><a href=\"https://jira-di.atlassian.net/wiki/pages/viewpage.action?pageId=26640428\" target=\"_blank\" class=\"link fa fa-help\">{{ t('fileModalFormatHelp') }}</a>\n    <button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"action\">{{ t('fileModalUploadBtn') }}</button>\n  </div>\n</form>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/html/templates/fileUpload.jade
 ** module id = 82
 ** module chunks = 1
 **/